import _slicedToArray from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .verified-method-btn {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    border-radius: 10px;\n    letter-spacing: unset;\n    text-transform: unset;\n    min-height: 90px !important;\n  }\n\n  .icon-wrapper {\n    align-self: flex-start;\n    min-width: 22.5px;\n  }\n\n  .icon-wrapper i {\n    font-size: 1.5rem;\n    color: var(--teal);\n  }\n\n  .verified-method-info-wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    flex: 1;\n    padding: 0 0.5rem 0 0.5rem;\n  }\n\n  .verified-method-info-wrapper h5 {\n    margin-bottom: 0;\n    font-size: 1.15rem;\n  }\n\n  .verified-method-info-wrapper p {\n    margin-bottom: 0;\n    font-weight: normal;\n    text-align: left;\n    font-size: 0.9rem;\n  }\n\n  .icon-wrapper .fa-mobile-alt {\n    margin-top: 1.5px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Views } from '../TwoFactorAuthentication';
import { TwoFactorAuthenticationMethods } from '@tradingblock/types';
var StyledVerifiedMethodSelection = styled.div(_templateObject());
;

var VerifiedMethodSelection = function VerifiedMethodSelection(_ref) {
  var setCurrentView = _ref.setCurrentView,
      verifiedTwoFactorAuthenticationMethodsData = _ref.verifiedTwoFactorAuthenticationMethodsData,
      setSelectedVerifiedTwoFactorAuthenticationMethodData = _ref.setSelectedVerifiedTwoFactorAuthenticationMethodData;

  var _useState = useState(verifiedTwoFactorAuthenticationMethodsData),
      _useState2 = _slicedToArray(_useState, 2),
      sortedVerifiedTwoFactorAuthenticationMethodsData = _useState2[0],
      setSortedVerifiedTwoFactorAuthenticationMethodsData = _useState2[1];

  useEffect(function () {
    var tempSortedVerifiedTwoFactorAuthenticationMethodsData = [];
    var verifiedSmsTwoFactorAuthenticationMethodData = verifiedTwoFactorAuthenticationMethodsData.find(function (verifiedTwoFactorAuthenticationMethodData) {
      return verifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.sms;
    });
    var verifiedEmailTwoFactorAuthenticationMethodData = verifiedTwoFactorAuthenticationMethodsData.find(function (verifiedTwoFactorAuthenticationMethodData) {
      return verifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.email;
    });

    if (verifiedSmsTwoFactorAuthenticationMethodData) {
      tempSortedVerifiedTwoFactorAuthenticationMethodsData.push(verifiedSmsTwoFactorAuthenticationMethodData);
    }

    if (verifiedEmailTwoFactorAuthenticationMethodData) {
      tempSortedVerifiedTwoFactorAuthenticationMethodsData.push(verifiedEmailTwoFactorAuthenticationMethodData);
    }

    setSortedVerifiedTwoFactorAuthenticationMethodsData(tempSortedVerifiedTwoFactorAuthenticationMethodsData);
  }, [verifiedTwoFactorAuthenticationMethodsData]);

  var handleVerifiedMethodBtnClick = function handleVerifiedMethodBtnClick(selectedVerifiedTwoFactorAuthenticationMethodData) {
    setCurrentView(Views.EnterSecurityCode);
    setSelectedVerifiedTwoFactorAuthenticationMethodData(selectedVerifiedTwoFactorAuthenticationMethodData);
  };

  return React.createElement(StyledVerifiedMethodSelection, null, React.createElement("p", null, "Please select the two-factor authentication (2FA) method you would like to use to complete the login process."), sortedVerifiedTwoFactorAuthenticationMethodsData.map(function (verifiedTwoFactorAuthenticationMethodData) {
    return React.createElement("button", {
      key: verifiedTwoFactorAuthenticationMethodData.twoFaType,
      className: "verified-method-btn btn btn-light btn-block",
      onClick: function onClick() {
        return handleVerifiedMethodBtnClick(verifiedTwoFactorAuthenticationMethodData);
      }
    }, React.createElement("div", {
      className: "icon-wrapper"
    }, verifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.sms && React.createElement("i", {
      className: "fal fa-mobile-alt fa-lg"
    }), verifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.email && React.createElement("i", {
      className: "fal fa-envelope fa-lg"
    })), React.createElement("div", {
      className: "verified-method-info-wrapper"
    }, React.createElement("h5", null, function () {
      if (verifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.sms) {
        return 'Text';
      } else if (verifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.email) {
        return 'Email';
      }
    }()), verifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.sms && React.createElement("p", null, "We'll text a security code to: ", verifiedTwoFactorAuthenticationMethodData.phoneNumber, "."), verifiedTwoFactorAuthenticationMethodData.twoFaType === TwoFactorAuthenticationMethods.email && React.createElement("p", null, "We'll email a security code to: ", verifiedTwoFactorAuthenticationMethodData.email, ".")));
  }));
};

export default VerifiedMethodSelection;